import {
  APP_SETTING_TOGGLE_PWA_BEGIN,
  APP_SETTING_TOGGLE_PWA_SUCCESS,
  APP_SETTING_TOGGLE_PWA_FAILURE,
  APP_SETTING_TOGGLE_PWA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function togglePwa(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_TOGGLE_PWA_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/toggle-pwa`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_TOGGLE_PWA_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_TOGGLE_PWA_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_TOGGLE_PWA_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissTogglePwaError() {
  return {
    type: APP_SETTING_TOGGLE_PWA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_TOGGLE_PWA_BEGIN:
      return {
        ...state,
        togglePwaPending: true,
        togglePwaError: null,
      };

    case APP_SETTING_TOGGLE_PWA_SUCCESS:
      return {
        ...state,
        togglePwaPending: false,
        togglePwaError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_TOGGLE_PWA_FAILURE:
      return {
        ...state,
        togglePwaPending: false,
        togglePwaError: action.data.error,
      };

    case APP_SETTING_TOGGLE_PWA_DISMISS_ERROR:
      return {
        ...state,
        togglePwaError: null,
      };

    default:
      return state;
  }
}
